import { render, staticRenderFns } from "./TicketSystemFaq.vue?vue&type=template&id=06ca5d2a&scoped=true"
import script from "./TicketSystemFaq.vue?vue&type=script&lang=js"
export * from "./TicketSystemFaq.vue?vue&type=script&lang=js"
import style0 from "./TicketSystemFaq.vue?vue&type=style&index=0&id=06ca5d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca5d2a",
  null
  
)

export default component.exports